import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import getNodeKey from '../../../../../services/mini/getKeyNode';
import getConversationId from '../../../../../services/mini/getConversationId';
import DialogItem from './DialogItem';
import RequestEditor from '../RequestEditor/RequestEditor';

class DialogItemHolder extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showTopEditor: false,
            savingNodeBefore: false
        };
    }

    showEditorForNodeBefore = () => {
        this.setState({ showTopEditor: !this.state.showTopEditor });
    }

    addNodeBefore = ({ text }) => {
        const { dialog, node, direction, conversationId, addText, dialogTree, onSave } = this.props;
        const { savingNodeBefore } = this.state;

        if (savingNodeBefore) return;

        this.setState({ savingNodeBefore: true }, () => {
            addText({
                dialog: dialog || [],
                dialogTree,
                text,
                curNode: node,
                conversationId,
                direction: 'before'
            }).then(() => {
                this.setState({ savingNodeBefore: false, showTopEditor: false });
            }, () => {
                this.setState({ savingNodeBefore: false });
            });
        });
    }

    render() {
        const { node, index, dialog } = this.props;
        const { showTopEditor, savingNodeBefore } = this.state;

        if (node.parentId === '' && _.isEmpty(node.request)) {
            return <React.Fragment />;
        }

        return (
            <div>
                {showTopEditor &&
                    <RequestEditor
                        type="add-request"
                        text={''}
                        node={node}
                        saving={savingNodeBefore}
                        onUpdate={this.addNodeBefore}
                        onExitEditMode={this.showEditorForNodeBefore} />}
                <DialogItem
                    key={getNodeKey(node)}
                    index={index}
                    node={node}
                    dialog={dialog}
                    onAddNodeBefore={this.showEditorForNodeBefore}
                />
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }) {
    return {
        dialogTree: testMode.dialogTree,
        conversationId: getConversationId(projectsInfo.currentProject.conversations)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addText: (param) => asyncDispatch(actions.addText, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogItemHolder);

